import { render, staticRenderFns } from "./BranchShape.vue?vue&type=template&id=054dd452&"
import script from "./BranchShape.vue?vue&type=script&lang=js&"
export * from "./BranchShape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports